import {createReducer} from "@reduxjs/toolkit";
import {UserActions} from "./user.action";

const initialState = {
  logged: false
};

export const UserReducer = {
  user: createReducer(initialState, (builder => {
    builder
      .addCase(UserActions.setUser, (state, action) => {
        return {
          ...state,
          logged:action.payload.logged

      }
      })
  }))
}
